module.exports = __webpack_public_path__ + "static/media/mood.43adc3f2.webp";